export class BaseUtilities {
    static forEach(array, action) {
        for (let i = 0; i < array.length; i++)
            action(array[i]);
    }
    static map(func, array) {
        const result = [];
        this.forEach(array, function (element) {
            result.push(func(element));
        });
        return result;
    }
    static dom(name, attributes, ...childs) {
        const node = document.createElement(name);
        if (attributes) {
            for (let key in attributes) {
                node.setAttribute(key, attributes[key]);
            }
        }
        for (let i = 0; i < childs.length; i++) {
            let child = childs[i];
            if (typeof child === 'string')
                child = document.createTextNode(child);
            node.appendChild(child);
        }
        return node;
    }
    static filter(func, array) {
        const result = [];
        this.forEach(array, function (element) {
            if (func(element)) {
                result.push(element);
            }
        });
        return result;
    }
    static getTimezoneOffset(dateObject, timezoneName) {
        const dateParts = dateObject.toLocaleString('ja', { timeZone: timezoneName }).split(/[\/\s:]/);
        let offset;
        dateParts[1] = parseInt('' + dateParts[1], 10) - 1;
        const time1 = Date.UTC.apply(null, dateParts);
        const time2 = new Date(dateObject).setMilliseconds(0);
        offset = (time2 - time1) / 60 / 1000;
        return offset;
    }
    static createDateWithTimezone(existingDate, timezoneName) {
        const localTime = existingDate.getTime(), localOffset = existingDate.getTimezoneOffset() * 60000, utc = localTime + localOffset, offset = this.getTimezoneOffset(existingDate, timezoneName) / 60, newTime = utc + 3600000 * offset;
        return new Date(newTime);
    }
    static shorten(text, length = 14) {
        const desiredLength = length;
        const textLength = text.split('').length;
        if (textLength > desiredLength) {
            return text.substring(0, desiredLength - 4) + '...';
        }
        else {
            return text;
        }
    }
    static setCookie(cookieName, value, days) {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + expirationDate.toUTCString();
        document.cookie = cookieName + '=' + value + ';' + expires;
    }
    static getCookie(cookieName) {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    static jsonEquals(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }
    static isInViewport(element) {
        const bounding = element.getBoundingClientRect();
        return (bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
    }
    static isObject(data) {
        return data && typeof data === 'object' && !Array.isArray(data);
    }
    static deepMerge(target, ...sources) {
        if (!sources.length)
            return target;
        const source = sources.shift();
        if (BaseUtilities.isObject(target) && BaseUtilities.isObject(source)) {
            for (const key in source) {
                if (BaseUtilities.isObject(source[key])) {
                    if (!target[key])
                        Object.assign(target, { [key]: {} });
                    BaseUtilities.deepMerge(target[key], source[key]);
                }
                else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return BaseUtilities.deepMerge(target, ...sources);
    }
}
